/**
 * /Recon — Stripe Checkout cancellation return URL.
 *
 * Reached when the client backs out of Stripe Checkout. The
 * authorization signature still stands; only payment is missing, so
 * the assessment hasn't started.
 *
 * Visual: single-section recon hero, mirrors
 * commission-confirmation.tsx. No trust dot here — the trust dot is a
 * success indicator (signal-green) and this page reports a non-event,
 * not a confirmed state.
 *
 * The legacy implementation referenced .wizard-container /
 * .wizard-step / .wizard-actions classes that were deleted with the
 * IntakeWizard in commit 18b1c06; the page rendered unstyled until
 * this rebuild.
 */
import { Link } from "react-router-dom";

export function PaymentCancelledPage() {
  return (
    <div className="recon-page">
      <section className="recon-hero">
        <div className="recon-hero-inner">
          <div className="eyebrow recon-hero-eyebrow">/RECON · PAYMENT CANCELLED</div>
          <h1 className="recon-hero-title">
            Payment was not completed.
          </h1>
          <p className="recon-hero-sub">
            Your authorization has been signed, but the engagement won't begin
            until payment lands. Reach out to your assessor if you need a
            different arrangement — invoice, wire, or retainer.
          </p>
          <div className="recon-hero-cta">
            {/* Link to /portal (the authenticated dashboard) not / —
                the root route redirects to /portal/login regardless of
                auth state, which made an already-authenticated user
                think they'd been signed out when they came back from
                Stripe's cancel button. */}
            <Link to="/portal" className="recon-btn recon-btn-secondary recon-btn-lg">
              Back to your dashboard
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
